import React from 'react';
import axios from 'axios';
import { Checkbox, Navbar, Tab, Row, Col, Nav, NavItem, Badge } from 'react-bootstrap';
import SummaryDataCollectionGroupPanel from './SummaryDataCollectionGroup/SummaryDataCollectionGroupPanel.js';
import BeamlineDataCollectionGroupPanel from './BeamlineDataCollectionGroup/BeamlineDataCollectionGroupPanel.js';
import SampleDataCollectionGroupPanel from './SampleDataCollectionGroup/SampleDataCollectionGroupPanel.js';
import DataCollectionListDataCollectionGroupPanel from './DataCollectionListDataCollectionGroup/DataCollectionListDataCollectionGroupPanel.js';
import ResultListDataCollectionGroupPanel from './ResultListDataCollectionGroup/ResultListDataCollectionGroupPanel.js';
import WorkflowDataCollectionGroupPanel from './WorkflowDataCollectionGroup/WorkflowDataCollectionGroupPanel.js';
import PhasingDataCollectionGroup from './PhasingDataCollectionGroup/PhasingDataCollectionGroup.js';
import { getPhasingByDataCollectionGroupId, getDataCollectionByGroupId, getAutoprocResultsByDataCollectionId } from '../../../api/ispyb.js';
import _ from 'lodash';
import './DataCollectionGroupPanel.css';

export class DataCollectionGroupPanel extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            dataCollection : {
                data : [],
                fetching : false,
                fetched : false
            },
            results : {
                data : [],
                fetching : false,
                fetched : false
            },
            phasing : {
                data : [],
                fetching : false,
                fetched : false
            },            
            activeKey: "Summary"
        };

        
        this.handleSelect = this.handleSelect.bind(this);
        this.handleSelectDataset = this.handleSelectDataset.bind(this);
        
    }
    parseStartTimeList(){
        if (this.props.datacollectiongroup.startTimeList){
            try{
                return this.props.datacollectiongroup.startTimeList.split(',')[0];
            }
            catch(e){
                return null;
            }
        }
    }

    
    handleSelect(key) {                 
       this.setState({
           activeKey : key
       });
        if (key === 'Phasing'){
            axios({
                method: 'GET',
                url: getPhasingByDataCollectionGroupId(this.props.user, this.props.datacollectiongroup.proposal, this.props.datacollectiongroup.dataCollectionGroupId),            
            })
            .then((response) => {                
                this.setState({
                    phasing : {
                        data : response.data,
                        fetching : false,
                        fetched : true
                    }
                });          
                
            })
            .catch((error)=>{            
                this.setState({    
                    phasing : {  
                        data : [],              
                        fetching : false,
                        fetched : false
                    }
                });  
            });
        }
        if (key === 'Collections' ){                                          
            axios({
                method: 'GET',
                url: getDataCollectionByGroupId(this.props.user, this.props.datacollectiongroup.proposal, this.props.datacollectiongroup.dataCollectionGroupId),            
            })
            .then((response) => {                
                this.setState({
                    dataCollection : {
                        data : response.data,
                        fetching : false,
                        fetched : true
                    }
                });          
                
            })
            .catch((error)=>{            
                this.setState({    
                    dataCollection : {  
                        data : [],              
                        fetching : false,
                        fetched : false
                    }
                });  
            });
        }      


         if (key === 'Results' ){                                        
            axios({
                method: 'GET',
                url: getAutoprocResultsByDataCollectionId(this.props.user, this.props.datacollectiongroup.proposal, this.props.datacollectiongroup.dataCollectionId),            
            })
            .then((response) => {                 
                this.setState({                    
                    results : {
                        data : response.data[0],
                        fetching : false,
                        fetched : true
                    }
                });  

                
            })
            .catch((error)=>{                            
                this.setState({    
                    results : {  
                        data : [],              
                        fetching : false,
                        fetched : false
                    }
                });  
            });
        }      
    }

    handleSelectDataset(e){        
        if (e.target.checked){
            this.props.selectDataCollectionGroup(this.props.datacollectiongroup)
        }
        else{
            this.props.unselectDataCollectionGroup(this.props.datacollectiongroup)
        }
    }
    isSelected(){
        var _this = this;           
        if (this.props.application.selectedDataCollectionGroups && _this.props.datacollectiongroup){
            let found = _.find(this.props.application.selectedDataCollectionGroups, function(e){  return e.raw.DataCollectionGroup_dataCollectionGroupId === _this.props.datacollectiongroup.raw.DataCollectionGroup_dataCollectionGroupId});                      
            if (found){            
                return true;
            };
        }
        return false;
    }
    render() {            
        let isSelected = this.isSelected();                
        function getClassName(isSelected){
            if (isSelected){
                return "navbar-selected"; 
            }
        }
                
        return <div style={{ borderLeft:'1px solid #f2f2f2',borderRight:'1px solid #f2f2f2', borderBottom:'1px solid #f2f2f2',borderRadius: '15px'}}>
        <Navbar className={getClassName(isSelected)} collapseOnSelect fluid  inverse>
                <Navbar.Header >
                    <Navbar.Brand> 
                    <Checkbox disabled checked={isSelected} onChange={this.handleSelectDataset}></Checkbox>

                        <span style={{fontSize:'14px', marginLeft:'10px'}}>{this.parseStartTimeList()}</span>
                        <span style={{marginLeft:'30px'}}>{this.props.datacollectiongroup.experimentType} </span> 
                    </Navbar.Brand>
                    <Navbar.Toggle />
                </Navbar.Header>
                <Navbar.Collapse>                 
                    <Nav pullRight>
                                        <NavItem eventKey="Summary" href="#"  onSelect={this.handleSelect.bind(this)}>
                                            Summary
                                        </NavItem>
                                        <NavItem eventKey="Beamline" href="#" onSelect={this.handleSelect.bind(this)}>
                                            Beamline Parameters
                                        </NavItem>
                                        { this.props.configuration.settings.MX.showCollectionTab &&
                                            <NavItem eventKey="Collections" href="#"  onSelect={this.handleSelect.bind(this)}>
                                                Collections <Badge>{this.props.datacollectiongroup.totalNumberOfDataCollections}</Badge>
                                            </NavItem>
                                        }
                                        <NavItem eventKey="Sample" href="#" onSelect={this.handleSelect.bind(this)}>
                                            Sample
                                        </NavItem>
                                        <NavItem eventKey="Results" href="#" onSelect={this.handleSelect.bind(this)}>
                                            Results <Badge>{this.props.datacollectiongroup.resultCount}</Badge>
                                        </NavItem>
                                        <NavItem eventKey="Workflows" href="#" onSelect={this.handleSelect.bind(this)}>
                                            Workflows <Badge>{this.props.datacollectiongroup.workflowCount}</Badge>
                                        </NavItem>
                                        <NavItem eventKey="Phasing" href="#" onSelect={this.handleSelect.bind(this)}>
                                                Phasing <Badge>{this.props.datacollectiongroup.hasPhasing}</Badge>
                                        </NavItem>
                                       
                                    </Nav>
                    </Navbar.Collapse>
                </Navbar>

       
                <Tab.Container id={this.props.dataCollectionId} activeKey={this.state.activeKey}>
                        <Row className="clearfix">                          
                            <Col sm={12}>
                            <Tab.Content animation>
                                <Tab.Pane eventKey="Summary" className="datacollectionTab">
                                        <SummaryDataCollectionGroupPanel 
                                        datacollectiongroup={this.props.datacollectiongroup} 
                                        jobs={this.props.jobs} 
                                        configuration={this.props.configuration} 
                                        processDataCollection={this.props.processDataCollection}
                                        processDataCollectionGroup={this.props.processDataCollectionGroup} 
                                        proposal={this.props.proposal}                  
                                        user={this.props.user} >                                            
                                        </SummaryDataCollectionGroupPanel>
                                </Tab.Pane>
                                <Tab.Pane eventKey="Beamline" className="datacollectionTab">
                                        <BeamlineDataCollectionGroupPanel {...this.props}></BeamlineDataCollectionGroupPanel>
                                </Tab.Pane>
                                { this.props.configuration.settings.MX.showCollectionTab &&
                                    <Tab.Pane eventKey="Collections"  className="datacollectionTab">
                                        <div style={{margin:'10px'}}> 
                                            <DataCollectionListDataCollectionGroupPanel 
                                                fetching={this.state.dataCollection.fetching} 
                                                dataCollections={this.state.dataCollection.data}    
                                                processDataCollection={this.props.processDataCollection} 
                                                selectDataCollection={this.props.selectDataCollection}
                                                unselectDataCollection={this.props.unselectDataCollection}
                                                proposal={this.props.proposal}                  
                                                user={this.props.user}    
                                                selectedDataCollections={this.props.application.selectedDataCollections} 
                                                jobs={this.props.jobs} 
                                                configuration={this.props.configuration}                    
                                                ></DataCollectionListDataCollectionGroupPanel>
                                        </div>
                                    </Tab.Pane>
                                }
                                <Tab.Pane eventKey="Sample"  className="datacollectionTab">
                                        <SampleDataCollectionGroupPanel  
                                        configuration={this.props.configuration} 
                                        user={this.props.user} 
                                         {...this.props}></SampleDataCollectionGroupPanel>
                                </Tab.Pane>
                                <Tab.Pane eventKey="Results"  className="datacollectionTab">
                                    <div style={{margin:'10px'}}> 
                                        <ResultListDataCollectionGroupPanel 
                                                fetching={this.state.results.fetching} 
                                                results={this.state.results.data} 
                                                user={this.props.user} 
                                                proposal={this.props.proposal} 
                                                configuration={this.props.configuration} 
                                                processDataCollection={this.props.processDataCollection}
                                                jobs={this.props.jobs} 
                                                ></ResultListDataCollectionGroupPanel>
                                     </div>
                                </Tab.Pane>  
                                <Tab.Pane eventKey="Workflows"  className="datacollectionTab">
                                        <WorkflowDataCollectionGroupPanel
                                            workflowStepTypes={this.props.workflowStepTypes}
                                            workflowStepIds={this.props.workflowStepIds}
                                            workflowStepStatuses={this.props.workflowStepStatuses}
                                            workflowId={this.props.workflowId}
                                            sessionId={this.props.sessionId}
                                            user={this.props.user} 
                                            proposal={this.props.proposal} 
                                            datacollectiongroup={this.props.datacollectiongroup}
                                        ></WorkflowDataCollectionGroupPanel>
                                </Tab.Pane>  
                                <Tab.Pane eventKey="Phasing"  className="datacollectionTab">
                                        <PhasingDataCollectionGroup                                      
                                            user={this.props.user} 
                                            proposal={this.props.proposal} 
                                            datacollectiongroup={this.props.datacollectiongroup}                                           
                                            fetching={this.state.phasing.fetching} 
                                            phasing={this.state.phasing.data} 
                                        ></PhasingDataCollectionGroup>
                                </Tab.Pane>  
                                     
                            </Tab.Content>
                            </Col>
                        </Row>
                        </Tab.Container>
                        </div>;


    }
}





// WEBPACK FOOTER //
// ./src/components/Mx/DataCollectionGroup/DataCollectionGroupPanel.js